function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M18 0c1.1046 0 2 .8954 2 2v16c0 1.1046-.8954 2-2 2H2c-1.1046 0-2-.8954-2-2V2C0 .8954.8954 0 2 0h16zm-1.153 14.6667H6.6825a.8.8 0 00-.8.8v1.0666a.8.8 0 00.8.8H16.847a.8.8 0 00.8-.8v-1.0666a.8.8 0 00-.8-.8zm0-6H6.6825a.8.8 0 00-.8.8v1.0666a.8.8 0 00.8.8H16.847a.8.8 0 00.8-.8V9.4667a.8.8 0 00-.8-.8zm0-6H6.6825a.8.8 0 00-.8.8v1.0666a.8.8 0 00.8.8H16.847a.8.8 0 00.8-.8V3.4667a.8.8 0 00-.8-.8zm-13.5294 0h-.7529a.8.8 0 00-.8.8v1.0666a.8.8 0 00.8.8h.753a.8.8 0 00.8-.8V3.4667a.8.8 0 00-.8-.8z"
});

function SvgCategory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#A8B8CA",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.7f22556b.svg";
export { ForwardRef as ReactComponent };